import * as z from "zod";
import { onboardingV2OverviewAnalyticsInputSchema } from "./overview-analytics-input";

export const onboardingsV2TimeSeriesDataPointSchema = z.object({
  date: z.string(),
  total: z.number().int().min(0),
  completed: z.number().int().min(0),
  reopened: z.number().int().min(0).optional(),
  abandoned: z.number().int().min(0),
  helpRequested: z.number().int().min(0),
});

export const onboardingsV2TimeSeriesSchema = z.object({
  dataPoints: z.array(onboardingsV2TimeSeriesDataPointSchema),
});

export const getOnboardingsV2OverviewTimeSeries = {
  name: "getOnboardingsV2OverviewTimeSeries" as const,
  input: onboardingV2OverviewAnalyticsInputSchema,
  output: onboardingsV2TimeSeriesSchema,
};

export type GetOnboardingsV2OverviewTimeSeriesInput = z.infer<
  typeof getOnboardingsV2OverviewTimeSeries.input
>;
export type GetOnboardingsV2OverviewTimeSeriesOutput = z.infer<
  typeof getOnboardingsV2OverviewTimeSeries.output
>;
export type OnboardingsV2TimeSeriesDataPoint = z.infer<
  typeof onboardingsV2TimeSeriesDataPointSchema
>;
